import { useField, useFormikContext } from 'formik'

import ImageUploader from 'components/ImageUploader'
import Loader from 'components/Loader'

import { submitImage } from 'utils/images'

const RevenueCenterImage = ({ isRevenueCenterImageLoading }) => {
  const [field, _, { setValue }] = useField('revenueCenterImage')
  const { setFieldTouched } = useFormikContext()

  const handleImageDragChange = (event) => {
    const file = event.dataTransfer.files?.[0] ?? null
    submitImage(event, file, setValue)
    setFieldTouched('revenueCenterImage', true, false)
  }

  const handleImageChange = (event) => {
    const file = event.target.files?.[0] ?? null
    submitImage(event, file, setValue)
    setFieldTouched('revenueCenterImage', true, false)
  }

  const handleRemoveImage = (event) => {
    event.preventDefault()
    setValue(null)
  }

  return (
    <div className="content-wrapper -flags-wrapper -block">
      <h3 className="header-title">Revenue center image</h3>
      <p className="modal-paragraph font-size-smaller">
        Revenue Center images are displayed in Mobile Ordering.
        Customer facing displays (CFD) will also display this image if
        a Menu image is not uploaded.
      </p>
      <div className="text-field padding-top-sm image-field-wrapper">
        {isRevenueCenterImageLoading ? (
          <Loader container={false} />
        ) : (
          <ImageUploader
            onRemoveImage={handleRemoveImage}
            onDragAndDropChange={handleImageDragChange}
            onImageChange={handleImageChange}
            image={field?.value}
            infoText="The recommended item image size is 740 x 492"
          />
        )}
      </div>
    </div>
  )
}

export default RevenueCenterImage
